module.exports = __webpack_public_path__ + "img/xmabsLeft_icon.png";